import React, { useEffect, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from './Colors';
import NewsletterForm from './NewsletterForm';
import { BodyMD, BodySM } from './TextTypes';

const ConsultationsModal: React.FC = () => {
  const { t } = useTranslation();
  const modalImage = 'https://images.prismic.io/ecommerce-website/0b4afd5d-da6d-4b04-9c9b-924835200fab_Frame+4.png?auto=compress,format';
  const consultationsListId = 'VVg8K6'; // This is the klaviyo list ID - https://www.klaviyo.com/list/VVg8K6/
  const [success, setSuccess] = useState(false);

  return (
    <Container>
      <TextColumn>
        <Text>
          {success ? (
            <BodyMD>{t('free-consultations.form-success-message')}</BodyMD>
          ) : (
            <>
              <BodyMD>{t('free-consultations.modal-body')}</BodyMD>
              <BodySMStyled>{t('free-consultations.modal-body-disclaimer')}</BodySMStyled>
            </>
          )}
        </Text>
        <NewsletterForm
          location="popup"
          listId={consultationsListId}
          style="popup"
          buttonTextKey={'free-consultations.modal-button-text'}
          onSuccess={() => setSuccess(true)}
        />
      </TextColumn>
      <ImageColumn>
        <img src={modalImage} />
      </ImageColumn>
    </Container>
  );
};

export default ConsultationsModal;

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const TextColumn = styled.div`
  display: flex;
  padding: 24px 32px 32px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  background: ${Colors.cream};
  flex-shrink: 0;
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
    padding: 24px;
  }

  & input {
    border-width: 1px;
  }

  & button {
    width: 100%;
    background: ${Colors.lilac};

    & p {
      color: ${Colors.cream};
    }
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BodySMStyled = styled(BodySM)`
  font-size: 12px;
`;

const ImageColumn = styled.div`
  flex-shrink: 0;
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
  }

  img {
    display: block;
  }
`;
